import { Typographies } from '@/theme';
import Colors from '@/theme/constants/Colors';
import { styled, AlertProps, AlertColor, alpha } from '@mui/material';

export const AlertStyled = styled('div')<AlertProps>(({ theme, severity }) => ({
  backgroundColor: getBackgroundByStatus(severity ?? 'success'),
  color: getColorByStatus(severity ?? 'success'),
  border: '1px solid',
  borderColor: getColorByStatus(severity ?? 'success'),
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0.8, 3),
  fontSize: Typographies.FONT_SIZE_H3,
  fontWeight: Typographies.FONT_WEIGHT_H3,
  letterSpacing: -0.2,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const getBackgroundByStatus = (type: AlertColor): string => {
  switch (type) {
    case 'success':
      return Colors.SECONDARY_LIGHT;
    case 'error':
      return alpha(Colors.DANGER_MAIN, 0.6);

    default:
      return Colors.SECONDARY_LIGHT;
  }
};

export const getColorByStatus = (type: AlertColor): string => {
  switch (type) {
    case 'success':
      return Colors.SECONDARY_MAIN;
    case 'error':
      return Colors.DANGER_MAIN;

    default:
      return Colors.SECONDARY_MAIN;
  }
};
